import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC, useState } from "react";

interface IHoldProductionOrderModal {
  open: boolean;
  onHoldProductionOrder: (jobNumber: string, reason: string) => void;
  onClose: () => void;
  jobNumber: string;
}

export const HoldProductionOrderModal: FC<IHoldProductionOrderModal> = ({
  open,
  onHoldProductionOrder,
  onClose,
  jobNumber,
}) => {
  const [reason, setReason] = useState("");

  const changeHandler = (event: any) => {
    setReason(event.value);
  };

  let textareaObj: any;

  function onCreate() {
    textareaObj.addAttributes({ rows: 1 });
    textareaObj.respectiveElement.style.height = "auto";
    textareaObj.respectiveElement.style.height = "300px";
  }

  const buttons = [
    {
      buttonModel: {
        content: "OK",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        onHoldProductionOrder(jobNumber, reason);
      },
    },
    {
      buttonModel: {
        content: "Cancel",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 200 };

  return (
    <DialogComponent
      width="600px"
      close={onClose}
      header={`Add Flag On Hold to ${jobNumber} - Job Number `}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      <TextBoxComponent
        ref={(scope : TextBoxComponent) => {
          textareaObj = scope;
        }}
        multiline={true}
        placeholder="Enter reason"
        value={reason}
        created={onCreate}
        input={changeHandler}
      />
    </DialogComponent>
  );
};
